import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/poster-optimized_water.avif")